import SwiperElement from "../molecules/SwiperElement";
import {Tracking} from "../../tracking/tracking";
import {paramsZoom, slideChangeTracker} from "./productSwiper";

declare const c: {
  revealPopup: (selector: string) => void;
};

class BwareSwiper {
  public static run(galleryAnchors: NodeListOf<HTMLAnchorElement>) {
    galleryAnchors.forEach(anchor => {
      anchor.addEventListener("click", (evt) => {
        evt.preventDefault();
        const itemId = (evt.currentTarget as HTMLAnchorElement).dataset.itemid;
        if (!itemId) return;
        c.revealPopup(`#DesignSalePopup${itemId}`);
        Tracking.sendEvent("OutletSwiper.Revealed");
        const container = document.querySelector(`.swiper-container[data-itemid="${itemId}"]`) as HTMLElement;
        if (paramsZoom.on) {
          paramsZoom.on.slideChange = slideChangeTracker("OutletSwiper.Swiped");
        }
        paramsZoom.loop = false;
        SwiperElement.run(container, paramsZoom);
      });
    });
  }
}

export default BwareSwiper;
